import React from "react";
import { Helmet } from "react-helmet";

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>404 - Seite nicht gefunden | Digitale Zahnpraxis Dr. Alshoutaiui</title>
        <meta name="robots" content="noindex, follow" />
        <meta name="description" content="Die angeforderte Seite existiert nicht. Bitte nutzen Sie unsere Navigation oder kontaktieren Sie uns direkt." />
        <link rel="canonical" href="https://digitalezahnpraxis.at/404" />
      </Helmet>

      <div className="bg-gray-500">
      <div className="container text-center mt-8 py-20  ">
          <div className="inline-block align-middle mx-auto ">
            <h1 className="text-9xl text-red-400 font-Poppins">404</h1>
            <h1 className="text-7xl text-white font-Poppins py-2">
              oops! Page not found
            </h1>
            <h1 className="text-2xl text-white font-Poppins">
              Oops! The page you are looking for does not exist. It might have
              been moved or deleted.
            </h1>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;